import React from 'react'
import styled from 'styled-components'
import { DarkTheme } from '../components/Themes'
import { NavLink } from 'react-router-dom'

const Logo = styled(NavLink)`
  display: inline-block;
  color: ${props => props.color === 'dark' ? DarkTheme.text : DarkTheme.body};
  font-family: 'Pacifico', cursive;
  position: fixed;
  left: 2rem;
  top: 2rem;
  font-size:1.5rem;
  z-index: 3;
  text-decoration: none; /* Remove underline from the link */
`;

const LogoComponent = (props) => {
    return (
        <Logo to="/" color={props.theme}>
          J4web
        </Logo>
    )
}

export default LogoComponent
